import { useEffect, useRef, useState } from "react";
import './styles/FooterWithSignup.css';
import api from "../../api/api";

function FooterWithSignup() {
    const imageRef = useRef<HTMLDivElement>(null);
    const [imageVisible, setImageVisible] = useState(false);

    const [form, setForm] = useState({
        name: "",
        email: "",
        cellphone: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.target.id]: e.target.value
        });
    };

    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);

            await api.post("/newsletter-signup", form);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "newsletter_signup",
            });

            setSubmitted(true);

            setForm({
                name: "",
                email: "",
                cellphone: ""
            });

            setForm({
                name: "",
                email: "",
                cellphone: ""
            });

        } catch (e) {
            alert("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!imageRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setImageVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.25,
            }
        );

        observer.observe(imageRef.current);

        return () => observer.disconnect();
    }, []);
    return (
        <div className="footer-with-signup">
            <div className="signup-container">
                <div className="signup-inner">
                    <div className="signup-left">
                        <div className="signup-left-body">
                            <h1>Sign Up</h1>
                            <h2>Join Our Community</h2>
                            <p>Join our Newsletter and our WhatsApp Broadcast Group with just one click! Enjoy exclusive recipes, special offers, and exciting new products.</p>
                            <p>Don’t miss out-sign up today and experience the joy of cooking with DENNY!</p>
                            <div className="signup-contact">

                                <div className="contact-row">
                                    <div className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                                            <g id="Path_14070" data-name="Path 14070"  fill="#fff" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M 19.94231033325195 22.75 L 17.63462066650391 22.75 C 13.39182090759277 22.75 9.402871131896973 21.09768104553223 6.402600765228271 18.0974006652832 C 3.402320861816406 15.09713077545166 1.750000953674316 11.10818099975586 1.750000953674316 6.865380764007568 L 1.750000953674316 4.557691097259521 C 1.750000953674316 3.009521007537842 3.009521007537842 1.750000953674316 4.557691097259521 1.750000953674316 L 5.964870929718018 1.750000953674316 C 6.724950790405273 1.750240921974182 7.384490966796875 2.265300989151001 7.568901062011719 3.002511024475098 L 8.70327091217041 7.538970947265625 C 8.865711212158203 8.187200546264648 8.624860763549805 8.864411354064941 8.089631080627441 9.263991355895996 L 6.764410972595215 10.25816059112549 C 6.545830726623535 10.42210102081299 6.457251071929932 10.69081115722656 6.543951034545898 10.92683124542236 C 7.744771003723145 14.19310092926025 10.3068904876709 16.75522041320801 13.57330131530762 17.95610046386719 C 13.63250064849854 17.97784042358398 13.69443130493164 17.9888916015625 13.75724124908447 17.9888916015625 C 13.94172096252441 17.9888916015625 14.1228609085083 17.89421081542969 14.24179077148438 17.73564147949219 L 15.23671054840088 16.4094409942627 C 15.54698085784912 15.99497127532959 16.0417308807373 15.74729061126709 16.55986022949219 15.74729061126709 C 16.69481086730957 15.74729061126709 16.82978057861328 15.76392078399658 16.96102142333984 15.79673099517822 L 21.49745178222656 16.93110084533691 C 22.23483085632324 17.11507034301758 22.75 17.77470016479492 22.75 18.53513145446777 L 22.75 19.94231033325195 C 22.75 21.49048042297363 21.49048042297363 22.75 19.94231033325195 22.75 Z" stroke="none"/>
                                                <path d="M 4.55769157409668 2.250001907348633 C 3.283191680908203 2.250001907348633 2.250001907348633 3.283191680908203 2.250001907348633 4.55769157409668 L 2.250001907348633 6.865381240844727 C 2.250001907348633 15.36180114746094 9.138200759887695 22.25 17.63462066650391 22.25 L 19.94231033325195 22.25 C 21.21681022644043 22.25 22.25 21.21681022644043 22.25 19.94231033325195 L 22.25 18.53513145446777 C 22.25 18.00590133666992 21.89000129699707 17.54436111450195 21.37615013122559 17.41616058349609 L 16.83975028991699 16.28180122375488 C 16.38845825195312 16.16898155212402 15.91460990905762 16.33821105957031 15.63667106628418 16.70949172973633 L 14.64179134368896 18.03564071655273 C 14.35256004333496 18.42127990722656 13.85307598114014 18.5915412902832 13.40077114105225 18.42539024353027 C 10.00243091583252 17.17601013183594 7.323991775512695 14.49758052825928 6.074611663818359 11.09923076629639 C 5.90846061706543 10.64692115783691 6.078720092773438 10.14744091033936 6.464361190795898 9.858201026916504 L 7.790510177612305 8.863330841064453 C 8.162820816040039 8.585380554199219 8.331020355224609 8.110511779785156 8.21820068359375 7.660261154174805 L 7.083841323852539 3.12384033203125 C 6.955410003662109 2.610401153564453 6.494131088256836 2.250171661376953 5.964870452880859 2.250001907348633 L 4.55769157409668 2.250001907348633 M 4.55769157409668 1.250001907348633 L 5.964870452880859 1.250001907348633 C 6.954870223999023 1.250320434570312 7.813800811767578 1.92108154296875 8.053951263427734 2.881181716918945 L 9.18833065032959 7.417671203613281 C 9.399870872497559 8.261890411376953 9.086060523986816 9.144070625305176 8.388740539550781 9.664650917053223 L 7.064460754394531 10.65813064575195 C 7.022510528564453 10.68959140777588 7.005260467529297 10.732590675354 7.013280868530273 10.75442123413086 C 8.163360595703125 13.88268089294434 10.6173210144043 16.33663177490234 13.74583053588867 17.4868106842041 C 13.74979114532471 17.48826026916504 13.75316143035889 17.4888916015625 13.75725078582764 17.4888916015625 C 13.77873134613037 17.4888916015625 13.81435108184814 17.47223091125488 13.8417911529541 17.43564033508301 L 14.83675098419189 16.10939025878906 C 15.24063110351562 15.5698709487915 15.88501071929932 15.24729061126709 16.55986022949219 15.24729061126709 C 16.73567199707031 15.24729061126709 16.91144180297852 15.26895141601562 17.08229064941406 15.31166076660156 L 21.61874008178711 16.44602966308594 C 22.5789909362793 16.68560028076172 23.25 17.54472160339355 23.25 18.53513145446777 L 23.25 19.94231033325195 C 23.25 21.76618194580078 21.76618194580078 23.25 19.94231033325195 23.25 L 17.63462066650391 23.25 C 13.25826072692871 23.25 9.143760681152344 21.5456714630127 6.049051284790039 18.45095062255859 C 2.954330444335938 15.35624122619629 1.250001907348633 11.24174118041992 1.250001907348633 6.865381240844727 L 1.250001907348633 4.55769157409668 C 1.250001907348633 2.733821868896484 2.733821868896484 1.250001907348633 4.55769157409668 1.250001907348633 Z" stroke="none" fill="#d6b591"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="contact">
                                        <a target="_blank" rel="noreferrer" href="tel:+27 23 614 2359">+27 23 614 2359</a>
                                    </div>
                                </div>
                                <div className="contact-row">
                                    <div className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16">
                                            <path id="Path_14071" data-name="Path 14071" d="M22.25,6.75v10.5a2.279,2.279,0,0,1-2.308,2.25H4.558A2.279,2.279,0,0,1,2.25,17.25V6.75m20,0A2.279,2.279,0,0,0,19.942,4.5H4.558A2.279,2.279,0,0,0,2.25,6.75m20,0v.243a2.238,2.238,0,0,1-1.1,1.916L13.46,13.524a2.358,2.358,0,0,1-2.421,0L3.347,8.91a2.238,2.238,0,0,1-1.1-1.916V6.75" transform="translate(-1.75 -4)" fill="#fff" stroke="#d6b591" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                        </svg>

                                    </div>
                                    <div className="contact">
                                        <a target="_blank" rel="noreferrer" href="mailto:email@denny.co.za">email@denny.co.za</a>
                                    </div>
                                </div>
                                <div className="contact-row">
                                    <div className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21">
                                            <g id="Group_819" data-name="Group 819" transform="translate(-4 -2.5)">
                                                <path id="Path_14073" data-name="Path 14073" d="M19.5,11c0,7.618-7.5,12-7.5,12S4.5,18.618,4.5,11A7.762,7.762,0,0,1,12,3a7.762,7.762,0,0,1,7.5,8Z" fill="#fff" stroke="#d6b591" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                                <path id="Path_14072" data-name="Path 14072" d="M15,10.5a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z" transform="translate(0 0.441)" fill="#d6b591"/>
                                            </g>
                                        </svg>

                                    </div>
                                    <div className="contact">
                                        <a target="_blank" rel="noreferrer" href="https://maps.app.goo.gl/qiLx97Ysc3aDyG2y7">12 Barlinka Avenue, Montagu, 6720</a>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="signup-left-form">
                            {submitted ? (
                                <div className="signup-success">
                                    <h3>Thank you for signing up!</h3>
                                    <p>
                                        You're now part of the DENNY community.
                                        Keep an eye on your inbox for delicious recipes,
                                        exciting new products and exclusive offers.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <div className="signup-left-form-fields">
                                        <input
                                            id="name"
                                            type="text"
                                            placeholder="Name"
                                            value={form.name}
                                            onChange={handleChange}
                                        />
                                        <input
                                            id="email"
                                            type="email"
                                            placeholder="Email Address"
                                            value={form.email}
                                            onChange={handleChange}
                                        />
                                        <input
                                            id="cellphone"
                                            type="text"
                                            placeholder="Phone Number"
                                            value={form.cellphone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "Signing Up..." : "Sign Up"}
                                    </button>

                                    <p className="sign-up-footer">
                                        *By clicking Sign Up you’re confirming that you agree with our Terms and Conditions
                                    </p>
                                </>
                            )}
                        </div>

                    </div>
                    <div
                        ref={imageRef}
                        className={`signup-right ${imageVisible ? "visible" : ""}`}
                    >
                        <img src={"/denny-food-image.png"} alt="Food Image" />
                    </div>
                </div>
            </div>

            <div className="footer">
                <div className="footer-top">
                    <img src={'/denny logo.svg'} alt="Denny Logo"/>
                    <p className="footer-body">For more than 70 years, DENNY has been a Proudly South African household name.</p>
                    <div className="footer-links">
                        <div className="footer-nav">
                            <a href="/lets-cook" className="footer-link">Let's Cook</a> |
                            <a href="/recipes" className="footer-link">Recipes</a> |
                            <a href="/products" className="footer-link">Products</a> |
                            <a href="/about-us" className="footer-link">About Us</a> |
                            <a href="/fan-recipes" className="footer-link">Fan Recipes</a> |
                            <a href="/campaigns" className="footer-link">Campaigns</a> |
                            <a href="/blogs" className="footer-link">Blogs</a> |
                            <a href="/contact-us" className="footer-link">Contact Us</a>

                        </div>
                        <div className="footer-socials">
                            <div className="social-icon" onClick={() =>
                                window.open(
                                    'https://www.facebook.com/dennysouthafrica/',
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="#022161" d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.6-1.6h1.7V4.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.2V11H8v3h2.7v8h2.8z"/>
                                </svg>
                            </div>
                            <div className="social-icon" onClick={() =>
                                window.open(
                                    'https://www.instagram.com/dennysouthafrica/',
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="#022161" d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm0 2A2.5 2.5 0 1 1 9.5 12 2.5 2.5 0 0 1 12 9.5zm5-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/>
                                </svg>
                            </div>
                            <div className="social-icon" onClick={() =>
                                window.open(
                                    'https://www.youtube.com/channel/UCaNSv69U1KKso7Zj800bR7A',
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="#022161" d="M23 12s0-3.1-.4-4.5c-.2-.8-.9-1.5-1.7-1.7C19.5 5.4 12 5.4 12 5.4s-7.5 0-8.9.4c-.8.2-1.5.9-1.7 1.7C1 8.9 1 12 1 12s0 3.1.4 4.5c.2.8.9 1.5 1.7 1.7 1.4.4 8.9.4 8.9.4s7.5 0 8.9-.4c.8-.2 1.5-.9 1.7-1.7.4-1.4.4-4.5.4-4.5zm-13 3.2V8.8L16 12l-6 3.2z"/>
                                </svg>
                            </div>
                        </div>

                    </div>
                    <div className="footer-links-legal">
                        <div className="footer-nav">
                            <a href="/privacy-policy" className="footer-link">Privacy Policy</a> |
                            <a href="/" className="footer-link">PAIA Manual</a> |
                            <a href="/" className="footer-link">Personal Information Protection Policy</a> |
                            <a href="/denny-cook-club-terms-conditions" className="footer-link">Terms & Conditions</a> |
                            <a href="/disclaimer" className="footer-link">Disclaimer</a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="libstar-logo">
                        <a href="https://www.libstar.co.za/"
                           target="_blank" rel="noreferrer"><img src={"/libstar logo.svg"} alt={"Libstar Logo"} /> </a>
                    </div>
                    <div className="copyright-footer">
                        LEARN MORE AT{" "}
                        <a
                            href="https://www.libstar.co.za/"
                            target="_blank" rel="noreferrer"
                            className="libstar-link"

                        >
                            WWW.LIBSTAR.CO.ZA
                        </a>
                        {" | "}
                        ©{new Date().getFullYear()} COPYRIGHT OF DENNY®. | ALL RIGHTS RESERVED.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterWithSignup;
